import React, { useEffect, useState } from 'react';
import { ProductCard } from '../components/ProductCard';
import { DeliveryOptions } from '../components/DeliveryOptions';
import { getSupabaseErrorMessage, loadProducts } from '../data/repository';
import { Product } from '../data/types';
const OFFER_POSITION_KEY = 'jumpland_offer_position';
type OfferPosition = {
  category: string;
  scrollY: number;
};
export function Products() {
  const savedPosition = getSavedOfferPosition();
  const [products, setProducts] = useState<Product[]>([]);
  const [category, setCategory] = useState(savedPosition?.category || 'Svi');
  const [error, setError] = useState('');
  useEffect(() => {
    void loadProducts().then(items => {
      setProducts(items.filter(item => item.isActive !== false));
      if (savedPosition) window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => window.scrollTo({
          top: savedPosition.scrollY,
          behavior: 'auto'
        }));
        sessionStorage.removeItem(OFFER_POSITION_KEY);
      });
    }).catch(loadError => setError(getSupabaseErrorMessage(loadError)));
  }, []);
  const saveOfferPosition = () => {
    sessionStorage.setItem(OFFER_POSITION_KEY, JSON.stringify({
      category,
      scrollY: window.scrollY
    }));
  };
  const categories = ['Svi', 'Napuhanci', 'Soft Play', 'Sport', 'Dodaci'];
  const visible = category === 'Svi' ? products : products.filter(product => product.category === category);
  return <div className="min-h-screen bg-background py-12" data-id="element-752" data-mp="18j0en0uvfpj2">
      <div className="max-w-7xl mx-auto px-4" data-id="element-753" data-mp="18hh0bfsrzojx">
        <header className="text-center mb-12" data-id="element-754" data-mp="1da0cc8btebmm">
          <h1 className="text-4xl md:text-5xl font-display font-bold text-gray-900" data-id="element-755" data-mp="1darvgjo86gw0">
            Naša ponuda
          </h1>
          <p className="mt-4 text-xl text-gray-600" data-id="element-756" data-mp="gprklpavnejs">
            Pregledajte našu ponudu za nezaboravnu zabavu.
          </p>
        </header>
        <div className="mb-12" data-id="element-757" data-mp="1o31s9m9js1zn">
          <DeliveryOptions data-id="element-758" data-mp="1o28vne4aysv8" />
        </div>
        <div className="mb-12 flex flex-wrap justify-center gap-2" data-id="element-759" data-mp="1j59ysnt987tc">
          {categories.map(item => <button key={item} type="button" onClick={() => {
          setCategory(item);
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }} className={`rounded-full px-6 py-3 text-sm font-bold ${category === item ? 'bg-gray-900 text-white' : 'border border-gray-100 bg-white text-gray-600 hover:bg-gray-50'}`} data-id="element-760" data-mp="1xuejcbniuo4m">
              {item}
            </button>)}
        </div>
        {error ? <p role="alert" className="rounded-2xl border border-red-200 bg-red-50 p-5 text-center text-red-800" data-id="element-761" data-mp="1a6ew3lpf5fus">
            {error}
          </p> : products.length === 0 ? <p className="py-16 text-center text-gray-500" data-id="element-762" data-mp="2t301j3ng0svg">Učitavamo ponudu…</p> : <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-763" data-mp="2t5coxwbyzvfw">
            {visible.map((product, index) => <ProductCard key={product.id} product={product} index={index} onOpenProduct={saveOfferPosition} data-id="element-764" data-mp="2j5lwe06yzqig" data-mpi={index} />)}
          </div>}
        {!error && products.length > 0 && visible.length === 0 && <p className="py-16 text-center text-gray-500" data-id="element-765" data-mp="3gsucffo7c7d2">
            Nema proizvoda u ovoj kategoriji.
          </p>}
      </div>
    </div>;
}
function getSavedOfferPosition(): OfferPosition | null {
  try {
    const rawPosition = sessionStorage.getItem(OFFER_POSITION_KEY);
    if (!rawPosition) return null;
    const position = JSON.parse(rawPosition) as OfferPosition;
    if (typeof position.category !== 'string' || typeof position.scrollY !== 'number') return null;
    return position;
  } catch {
    return null;
  }
}